import React, { useState } from 'react';
import { notification } from 'antd';
import { WebsiteIndexEntry, UpdateWebsiteIndexEntrySettingsParams } from '../../../deepAnalysis/websiteIndexEntry/types';
import { useUpdateWebsiteIndexEntrySettingsMutation } from '../../../deepAnalysis/websiteIndexEntry/service';
import CompetitorsInput from './CompetitorsInput';
import CompetitorsTable from './CompetitorsTable';
import useGetPlanSettings from '../../../sales/hooks/useGetPlanSettings';


type Props = {
    selectedWebsite: WebsiteIndexEntry;
};


export default function CompetitorsTab({ selectedWebsite }: Props) {
    const [isAddingCompetitor, setIsAddingCompetitor] = useState<boolean>(false);
    const { maxCompetitors } = useGetPlanSettings();
    const [updateWebsiteIndexEntrySettings, { originalArgs, isLoading: isUpdatingSettings }] = useUpdateWebsiteIndexEntrySettingsMutation();

    const newCompetitors = originalArgs ? originalArgs.competitors! : [];

    const handleCompetitorsChange = async (args: UpdateWebsiteIndexEntrySettingsParams, action: "add" | "remove") => {
        try {
            if (action === 'add') {
                setIsAddingCompetitor(true);
            }

            await updateWebsiteIndexEntrySettings(args).unwrap();

            if (action === 'add') {
                setIsAddingCompetitor(false);
            }
        } catch (error: any) {
            setIsAddingCompetitor(false);
            notification.error({
                message: 'Error',
                description: error?.data?.message || 'Cannot update your competitors. Please try again!',
            });
        }
    };

    return (
        <div className="competitors-tab">
            <CompetitorsInput
                key={selectedWebsite.guid}
                selectedWebsite={selectedWebsite}
                isDisabled={!maxCompetitors || selectedWebsite.settings.competitors.length >= maxCompetitors}
                isAddingCompetitor={isAddingCompetitor}
                onCompetitorsChange={handleCompetitorsChange}
            />

            {selectedWebsite.settings.competitors.length > 0 ? (
                <CompetitorsTable
                    selectedWebsite={selectedWebsite}
                    remainingCompetitors={newCompetitors}
                    isRemovingCompetitor={isUpdatingSettings}
                    onCompetitorsChange={handleCompetitorsChange}
                />
            ) : null}
        </div>
    );
}
